import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Importing Components
import NavBar from './components/NavBar';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './pages/NotFound';

// Importing User Side Pages
import Home from './pages/Home';
import BookNow from './pages/BookNow';
import SingleHotelPage from './pages/SingleHotelPage';
import SingleRoomPage from './pages/SingleRoomPage';
import Support from './pages/Support';
import UserProfile from './pages/UserProfile';
import UserBookings from './pages/UserBookings';
import About from './pages/About';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Signup from './pages/Signup';
import SubmitReviewOrQuestion from './pages/SubmitReviewOrQuestion';
import BookingConfirmed from './pages/BookingConfirmed';
import AllPlaces from './pages/AllPlaces';

// Importing Admin Side Pages
import AdminPanelLayout from './admin/AdminPanelLayout';
import Dashboard from './admin/pages/Dashboard';
import Profile from './admin/pages/Profile';
import Places from './admin/pages/Places';
import UpdatePlace from './admin/pages/UpdatePlace';
import Hotels from './admin/pages/Hotels';
import UpdateHotel from './admin/pages/UpdateHotel';
import Rooms from './admin/pages/Rooms';
import UpdateRoom from './admin/pages/UpdateRoom';
import AllBookings from './admin/pages/AllBookings';
import UpdateBooking from './admin/pages/UpdateBooking';
import AllUsers from './admin/pages/AllUsers';
import UserFeedbacks from './admin/pages/UserFeedbacks';
import UserQueries from './admin/pages/UserQueries';

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>

          {/* User Side Routes */}
          <Route path='/' element={<NavBar/>}>
            <Route index element={<Home />} />
            <Route path='book-now' element={<BookNow />} />
            <Route path='book-now/:place' element={<BookNow />} />
            <Route path='all-places' element={<AllPlaces />} />
            <Route path='hotel/:hotelId' element={<SingleHotelPage />} />
            <Route path='room/:roomId' element={<SingleRoomPage />} />
            <Route path='support' element={<Support />} />
            <Route path='my-account' element={<ProtectedRoute component={<UserProfile />} />} />
            <Route path='my-bookings' element={<ProtectedRoute component={<UserBookings />} />} />
            <Route path='booking-confirmation/:bookingId' element={<BookingConfirmed/>} />
            <Route path='about-us' element={<About />} />
            <Route path='form/:query' element={<SubmitReviewOrQuestion />} />
          </Route>

          {/* Login/Signup Routes */}
          <Route path='/create-account' element={<Signup />} />
          <Route path='/login' element={<Login />} />
          <Route path='/logout' element={<Logout />} />

          {/* Admin Side Routes */}
          <Route path='/admin/dashboard' element={<AdminPanelLayout component={<Dashboard />} />} />
          <Route path='/admin/admin-profile' element={<AdminPanelLayout component={<Profile />} />} />
          <Route path='/admin/add-places' element={<AdminPanelLayout component={<Places />} />} />
          <Route path='/admin/add-hotels' element={<AdminPanelLayout component={<Hotels />} />} />
          <Route path='/admin/add-rooms' element={<AdminPanelLayout component={<Rooms />} />} />
          <Route path='/admin/all-bookings' element={<AdminPanelLayout component={<AllBookings />} />} />
          <Route path='/admin/all-users' element={<AdminPanelLayout component={<AllUsers />} />} />
          <Route path='/admin/feedbacks' element={<AdminPanelLayout component={<UserFeedbacks />} />} />
          <Route path='/admin/queries' element={<AdminPanelLayout component={<UserQueries />} />} />

          {/* Update Routes */}
          <Route path="/admin/edit-place/:placeCity" element={<AdminPanelLayout component={<UpdatePlace />} />} />
          <Route path="/admin/edit-hotel/:hotelId" element={<AdminPanelLayout component={<UpdateHotel />} />} />
          <Route path="/admin/edit-room/:roomId" element={<AdminPanelLayout component={<UpdateRoom />} />} />
          <Route path="/admin/edit-booking/:bookingId" element={<AdminPanelLayout component={<UpdateBooking />} />} />

          {/* Page Not Found Route */}
          <Route path='/' element={<NavBar/>}>
            <Route path='*' element={<NotFound />} />
          </Route>

        </Routes>
      </BrowserRouter>
    </>
  )
}